import React from 'react';
import Card from '@material-ui/core/Card';

/**
 * The about component giving more information about AIS
 * @component AboutPage
 * @return {Component} About component
 */
export default function AboutPage() {
  return (
    <Card style={{
      padding: '50px',
      width: '1200px',
      margin: '30px auto',
    }}>
      <div style={{borderBottom: '1px solid silver', paddingBottom: '5px'}}>
        <h1 style={{paddingBottom: '2px'}}>
          About Us</h1>
      </div>
      <br />
      <p>
        Advanced Intelligence Services Corp. is a biological and artificial
        intelligence research provider, exclusively serving the United States
        Department of Defense and it's corporate allies in emerging defense
        contexts, globally. AIS Corp. was established in 2006, and incorporated
        in 2010. Our mission is to ensure the safety and security of the United
        States, it's people, and it's global partners, long-term. At your
        convenience, learn more about AIS Corp. and discover why specialists
        prefer AIS Corp. over others in the same field.
      </p>
    </Card>
  );
}
